/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.border-full {
  border-radius: 9999px;
}

.icon {
  width: 50px;
  height: 50px;
}
.super-scroll-block-slide-card-logo {
  @apply max-h-100px h-full w-auto !important;
}

/* Home Banner Image Setup */
/* .home-banner-slide-asset {
  @apply w-full h-full object-cover rounded-[12px] !important;
}

@media (min-width: 1200px) {
  .home-banner-slide-asset {
    @apply max-h-[720px] !important;
  }
}

@media (max-width: 999px) {
  .home-banner-slide-asset {
    @apply max-h-[600px] !important;
  }
} */